import { graphql } from "../graphql";

export const GetFooter = graphql(/* GraphQL */ `
  query GetDefaultFooter($locale: String, $preview: Boolean) {
    footerCollection: c102FooterCollection(
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        ...FooterContent
      }
    }
  }
`);
